module.exports = __webpack_public_path__ + "files/5622a87708f35bdf0a6dedce20a458a8.png";